module.exports = __webpack_public_path__ + "static/media/luxbox.bb7f8214.jpeg";